import { render } from "./IndividuelleAngebote.vue?vue&type=template&id=2e0b48c6&scoped=true"
import script from "./IndividuelleAngebote.vue?vue&type=script&lang=js"
export * from "./IndividuelleAngebote.vue?vue&type=script&lang=js"

import "./IndividuelleAngebote.vue?vue&type=style&index=0&id=2e0b48c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0b48c6"]])

export default __exports__